import React from "react";
import { useOrganization } from "@/contexts/OrganizationContext";
import Home from "./Home";
import CrosierHome from "./CrosierHome";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Organization-aware homepage wrapper.
 * Routes to the appropriate homepage based on the current organization.
 */
const OrganizationHome: React.FC = () => {
  const { organization, isLoading } = useOrganization();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="max-w-4xl mx-auto space-y-8">
          <Skeleton className="h-64 w-full" />
          <Skeleton className="h-32 w-full" />
          <Skeleton className="h-48 w-full" />
        </div>
      </div>
    );
  }

  // Route to org-specific homepage based on slug
  switch (organization?.slug) {
    case 'spes':
      return <CrosierHome />;
    default:
      return <Home />;
  }
};

export default OrganizationHome;
